import { Link, makeStyles, tokens } from '@fluentui/react-components';
import type { IMetadata } from '@moko/utils';
import EntityCard from './EntityCard';
import { buildCardData } from './cardUtils';
import type { IStatusOption } from '../StatusBadge';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    maxWidth: '300px',
  },
  cta: {
    alignSelf: 'flex-end',
  },
});

export interface MapPopupCardProps {
  metadata: IMetadata;
  item: Record<string, unknown>;
  ctaLabel: string;
  onCtaClick: () => void;
  statuses?: readonly IStatusOption[];
}

const MapPopupCard = ({
  metadata,
  item,
  ctaLabel,
  onCtaClick,
  statuses,
}: MapPopupCardProps) => {
  const styles = useStyles();
  const data = buildCardData(metadata, item);
  return (
    <div className={styles.wrapper}>
      <EntityCard data={data} statuses={statuses} />
      <Link
        as="button"
        type="button"
        className={styles.cta}
        onClick={onCtaClick}
      >
        {ctaLabel}
      </Link>
    </div>
  );
};

export default MapPopupCard;
